import { CustomMediaPropsType } from '@/common/components/camera/types/components.type';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const CameraCustomMedia = ({
  photoRef,
  videoRef,
  cameraShot = false,
}: CustomMediaPropsType) => (
  <Box
    className={css({
      overflow: 'hidden',
      touchAction: 'none',
      overscrollBehaviorY: 'contain',
    })}
  >
    <Box
      style={{
        height: `calc(${window.innerHeight}px  - 80px)`,
      }}
    >
      <canvas
        className={css({
          display: 'none',
        })}
        ref={photoRef}
      />
      <video
        muted
        ref={videoRef}
        autoPlay
        playsInline
        className="remote-video"
        style={{
          objectFit: 'cover',
          width: '100%',
          height: '100%',
          opacity: cameraShot ? '0.1 ' : '1',
        }}
      />
    </Box>
  </Box>
);

export default CameraCustomMedia;
